import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getGrammar, highlight } from "./prism.js";
export function PrismCodeBlock({ language, code, title, children, }) {
    return (_jsxs("div", { className: `bg-gray-100 rounded`, children: [title && _jsx("div", { className: `px-3 pt-2`, children: title }), _jsx(PossiblyHighlightedCode, { language: language, code: code, children: children })] }));
}
function PossiblyHighlightedCode({ language = "none", code, children, }) {
    const { grammar, lang, className } = getGrammar(language);
    if (children) {
        return (_jsx("pre", { children: _jsx("code", { className: className, children: children }) }));
    }
    code = (code || "").trim();
    const html = {
        __html: highlight(code, grammar, lang),
    };
    return (_jsx("pre", { className: className, children: _jsx("code", { className: className, dangerouslySetInnerHTML: html }) }));
}
